import { DOMAIN } from "shared/SharedConstants";

/** The platform's overall state, from the public status page's summary. */
export type PlatformState = "operational" | "degraded" | "downtime" | "maintenance" | "unknown";

const STATES = new Set<PlatformState>(["operational", "degraded", "downtime", "maintenance"]);

/** The public status page: each monitored service's current state, history and incidents. */
export const STATUS_PAGE_URL = `https://status.${DOMAIN}`;

/** Where the app serves the state (cached), so visitors never contact the status page host. */
export const PLATFORM_STATUS_PATH = "/platform-status";

/** Reads the overall state from the status page's `index.json`; anything unexpected is unknown. */
export const parsePlatformState = (body: unknown): PlatformState => {
  const state = (body as { data?: { attributes?: { aggregate_state?: unknown } } } | null)?.data
    ?.attributes?.aggregate_state;
  return typeof state === "string" && STATES.has(state as PlatformState)
    ? (state as PlatformState)
    : "unknown";
};
